module.exports = __webpack_public_path__ + "sk-trip-wizard-card-bottom-right@2x.mb3YtmHJ.png";